'use strict';

exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
};
//# sourceMappingURL=ColorScheme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/ColorScheme.js
// module id = 404
// module chunks = 67997519577666